module.exports = __webpack_public_path__ + "static/media/products.7d34cd2f.svg";